import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "@kno2/core/auth";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { RedirectService } from "@kno2/core/routing";
import { SessionService } from "@kno2/core/session";

@Component({
    selector: "kno2-auth-login",
    template: ``
})
export class LoginComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly authService = inject(AuthService);
    private readonly redirectService = inject(RedirectService);
    private readonly sessionService = inject(SessionService);
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    public async ngOnInit(): Promise<void> {
        const loginType = this.route.snapshot.paramMap.get("loginType");
        const isPccLogin = loginType === "pcc" || loginType === "PointClickCare";
        const connection = isPccLogin ? (this.appConfig.auth0.pccConnection ?? "PointClickCare") : loginType;
        const authParams = connection ? { connection } : null;
        const target = this.redirectService.getRedirectUrl(true);
        const appState = target ? { target } : null;

        this.sessionService.removeProfile();
        await this.authService.login(authParams, appState);
    }
}
